import GeckoRequest from 'services/gecko-request';
import { reduxStore } from 'services/gecko-store/redux';

const dispatch = (event, payload = {}, metadata = {}) => {
  return reduxStore.dispatch({
    type: event,
    payload,
    metadata,
  });
};

export const fetchContacts = ({ page, order, orderBy, search } = {}) => {
  const fullState = reduxStore.getState();
  const state = fullState.contactsRoute;
  const mineOnly = fullState.location.slug === 'mine';
  page = page || state.page;
  order = order || state.order;
  orderBy = orderBy || state.orderBy;
  search = search !== undefined ? search : state.search;
  dispatch('CONTACTS_STARTED_FETCHING_CONTACTS', {
    page,
    order,
    orderBy,
    search,
  });
  GeckoRequest.get('/contact', { page, orderBy, order, search, mineOnly })
    .then((payload) => {
      const { data, page, nextPage, total } = payload;
      dispatch('CONTACTS_FETCHED_CONTACTS', { data, page, nextPage, total });
    })
    .catch((err) => {
      dispatch('CONTACTS_FAILED_FETCHING_CONTACTS', { error: err });
    });
};
